<ng-container *ngIf="job">
  <div
    *ngIf="!compact; else compactJobListItem"
    class="job-list-item"
    [attr.data-cy]="'job-list-item-id-' + job?._id"
    [class.available]="
      (poolerJobStatus$ | async) === InviteeStatusEnum.AVAILABLE
    "
    [class.booked]="(poolerJobStatus$ | async) === InviteeStatusEnum.BOOKED"
    [class.action-required]="
      (poolerJobStatus$ | async) === InviteeStatusEnum.UNAVAILABLE
    "
    [class.is-compact]="compact">
    <div class="header-meta">
      <app-job-list-item-date-time
        [job]="job"
        [withDate]="withDate"></app-job-list-item-date-time>
      <div
        *ngIf="job?.status === JobStatusEnum.ARCHIVED && hasHoursToRecord"
        class="attention-chip"
        data-cy="record-hours-chip">
        {{ "recordHours" | i18n }}
      </div>
    </div>
    <app-job-list-item-organisation-heading
      class="job-heading"
      [department]="job.department"
      [organisation]="
        job.organisation
      "></app-job-list-item-organisation-heading>
    <app-pooler-job-list-item-details-table
      class="details-table"
      [job]="job"></app-pooler-job-list-item-details-table>
    <div
      class="timetracking"
      *ngIf="
        job?.yourself?.timeTrackings &&
        !job?.yourself?.timeTrackings?.[0]?.disabled &&
        job?.yourself?.status == InviteeStatusEnum.BOOKED &&
        now >= job.jobStart
      ">
      <app-time-tracking
        [invitee]="job?.yourself"
        [job]="job"
        [isPooler]="true"></app-time-tracking>
    </div>
    <div class="job-footer">
      <div class="start-items"></div>
      <div class="end-items">
        <ng-container
          *ngIf="
            job?.yourself?.status === InviteeStatusEnum.OPEN &&
              job?.status === JobStatusEnum.OPEN && loggedInUser?.customerInformation?.[job?.yourself?.customer?.id || ''];
            else responseTemplate
          ">
          <button
            class="outline-pill-button text-error"
            type="button"
            (click)="onDeclineClick()"
            data-cy="decline-invitation-button">
            <mat-icon svgIcon="close"></mat-icon>
            {{
              (isPossibleJob ? "notIntrested" : "decline") | i18n | titlecase
            }}
          </button>
          <button
            *ngIf="allowPartial"
            class="outline-pill-button text-secondary"
            type="button"
            (click)="onPartialAcceptClick()"
            data-cy="partial-accept-invitation-button">
            <mat-icon svgIcon="check-brackets-partial-accept"></mat-icon>
            {{
              (isAutoBookJob ? "partialAccept" : "partiallyIntrested")
                | i18n
                | titlecase
            }}
          </button>
          <button
            class="outline-pill-button text-secondary"
            type="button"
            (click)="onAcceptClick()"
            data-cy="accept-invitation-button">
            <mat-icon svgIcon="check"></mat-icon>
            {{ (isAutoBookJob ? "accept" : "intrested") | i18n | titlecase }}
          </button>
        </ng-container>
        <ng-template #responseTemplate>
          <div
            class="response-status"
            [attr.data-cy]="
              'job-list-item-response-status-' + job?.yourself?.status
            "
            *ngIf="dateAndDistance$ | async as dateAndDistance">
            <ng-container [ngSwitch]="job?.yourself?.status">
              <ng-container *ngSwitchCase="InviteeStatusEnum.OPEN">
                <ng-container *ngIf="job.status === JobStatusEnum.CLOSED">
                  {{ "jobAlreadyOccupied" | i18n }}
                </ng-container>
                <ng-container *ngIf="job.status !== JobStatusEnum.CLOSED">
                  {{ "noResponseGiven" | i18n }}
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="InviteeStatusEnum.AVAILABLE">
                {{ "acceptedAt" | i18n: dateAndDistance }}
              </ng-container>
              <ng-container *ngSwitchCase="InviteeStatusEnum.PARTIAL_AVAILABLE">
                {{ "partialAcceptedAt" | i18n: dateAndDistance }}
              </ng-container>
              <ng-container *ngSwitchCase="InviteeStatusEnum.UNAVAILABLE">
                {{ "declinedAt" | i18n: dateAndDistance }}
              </ng-container>
              <ng-container *ngSwitchCase="InviteeStatusEnum.DECLINED">
                {{ "wasDeclinedAt" | i18n: dateAndDistance }}
              </ng-container>
              <ng-container *ngSwitchCase="InviteeStatusEnum.CANCELED">
                {{ "canceledAt" | i18n: dateAndDistance }}
              </ng-container>
              <ng-container
                *ngSwitchCase="InviteeStatusEnum.POSSIBLE_CANDIDATE">
                {{ "possibleCandidateAt" | i18n: dateAndDistance }}
              </ng-container>
              <ng-container *ngSwitchCase="InviteeStatusEnum.BOOKED">
                {{ "bookedAtWithDate" | i18n: dateAndDistance }}
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
        <button
          *ngIf="
            (job?.status !== JobStatusEnum.OPEN && (job?.yourself?.status !== InviteeStatusEnum.BOOKED || job?.yourself?.status === InviteeStatusEnum.CANCELED)) ||
            !loggedInUser?.customerInformation?.[job?.yourself?.customer?.id || '']
          "
          class="outline-pill-button text-primary"
          (click)="hideJob()"
          type="button"
          data-cy="hide-job-button">
          <span class="mat-fab__label">{{
            ("hide" | i18n) || "ausblenden" | titlecase
          }}</span>
        </button>
        <ng-container
          *ngIf="loggedInUser?.customerInformation?.[job?.yourself?.customer?.id || '']">
          <button
            *ngIf="
              job?.yourself?.status === InviteeStatusEnum.AVAILABLE ||
              job?.yourself?.status === InviteeStatusEnum.UNAVAILABLE ||
              job?.yourself?.status === InviteeStatusEnum.PARTIAL_AVAILABLE
            "
            class="outline-pill-button icon-only"
            data-cy="more-actions-button"
            type="button"
            [matMenuTriggerFor]="actionsMenu"
            [matTooltip]="
              ('moreOptions' | i18n) || 'weitere optionen' | titlecase
            "
            (click)="$event.stopPropagation()">
            <mat-icon svgIcon="menu-dot"></mat-icon>
          </button>
          <mat-menu
            #actionsMenu="matMenu"
            class="fixed-icon-mat-menu themed">
            <button
              *ngIf="job?.yourself?.status !== InviteeStatusEnum.UNAVAILABLE"
              mat-menu-item
              type="button"
              data-cy="change-response-to-decline-button"
              (click)="onDeclineClick()"
              class="danger-icon">
              <mat-icon svgIcon="close"></mat-icon>
              {{ "decline" | i18n }}
            </button>
            <button
              *ngIf="allowPartial"
              mat-menu-item
              type="button"
              data-cy="change-response-to-partial-button"
              (click)="onPartialAcceptClick()"
              class="success-icon">
              <mat-icon svgIcon="check-brackets-partial-accept"></mat-icon>
              {{
                (isAutoBookJob ? "partialAccept" : "partiallyIntrested")
                  | i18n
                  | titlecase
              }}
            </button>
            <button
              *ngIf="job?.yourself?.status !== InviteeStatusEnum.AVAILABLE"
              mat-menu-item
              type="button"
              data-cy="change-response-to-accept-button"
              (click)="onAcceptClick()"
              class="success-icon">
              <mat-icon svgIcon="check"></mat-icon>
              {{ (isAutoBookJob ? "accept" : "intrested") | i18n | titlecase }}
            </button>
          </mat-menu>
        </ng-container>
        <button
          *ngIf="job?.yourself?.status === InviteeStatusEnum.BOOKED"
          class="outline-pill-button icon-left"
          type="button"
          (click)="downloadICS()">
          <mat-icon svgIcon="calendar-plus-save-download"></mat-icon>
          <span class="mat-fab__label">{{
            ("icsDownload" | i18n) || "Kalender" | titlecase
          }}</span>
        </button>
      </div>
    </div>
  </div>

  <ng-template #compactJobListItem>
    <div
      class="compact-job-list-item-row"
      [attr.data-cy]="'job-list-item-id-' + job?._id">
      <div class="compact-job-list-item-backdrop"></div>
      <div class="status-bar-wrapper-container">
        <div class="status-bar-wrapper">
          <div
            class="status-bar"
            [matTooltip]="
              (poolerJobStatus$ | async) === InviteeStatusEnum.UNAVAILABLE
                ? ('noOpenInvitations' | i18n | titlecase)
                : (poolerJobStatus$ | async) === InviteeStatusEnum.BOOKED
                ? ('booked' | i18n | titlecase)
                : (poolerJobStatus$ | async) === InviteeStatusEnum.AVAILABLE
                ? ('hasAvailablePeople' | i18n | titlecase)
                : ('waitingForResponse' | i18n | titlecase)
            "
            [matTooltipShowDelay]="100"
            matTooltipPosition="above"
            [class.status-action-required]="
              (poolerJobStatus$ | async) === InviteeStatusEnum.UNAVAILABLE
            "
            [class.status-closed]="
              (poolerJobStatus$ | async) === InviteeStatusEnum.BOOKED
            "
            [class.status-has-available-invitees]="
              (poolerJobStatus$ | async) === InviteeStatusEnum.AVAILABLE
            "></div>
        </div>
      </div>
      <app-pooler-job-list-item-compact-content
        [job]="job"
        [columns]="columns"></app-pooler-job-list-item-compact-content>
      <div class="compact-job-list-item-footer">
        <button
          class="outline-pill-button icon-only"
          data-cy="more-actions-button"
          type="button"
          [matMenuTriggerFor]="compactActionsMenu"
          matTooltip="{{
            ('moreOptions' | i18n) || 'weitere optionen' | titlecase
          }}"
          (click)="$event.stopPropagation()">
          <mat-icon svgIcon="menu-dot"></mat-icon>
        </button>
      </div>
    </div>
    <mat-menu
      #compactActionsMenu="matMenu"
      class="fixed-icon-mat-menu themed">
      <button
        *ngIf="
          job?.status !== JobStatusEnum.OPEN &&
          (job?.yourself?.status !== InviteeStatusEnum.BOOKED ||
            job?.yourself?.status === InviteeStatusEnum.CANCELED)
        "
        mat-menu-item
        class="text-primary"
        (click)="hideJob()"
        type="button"
        data-cy="hide-job-button">
        <span class="mat-fab__label">{{
          ("hide" | i18n) || "ausblenden" | titlecase
        }}</span>
      </button>
      <ng-container
        *ngIf="
          job?.status === JobStatusEnum.OPEN &&
          job?.yourself?.status !== InviteeStatusEnum.POSSIBLE_CANDIDATE
        ">
        <button
          *ngIf="job?.yourself?.status !== InviteeStatusEnum.UNAVAILABLE"
          mat-menu-item
          type="button"
          data-cy="change-response-to-decline-button"
          (click)="onDeclineClick()"
          class="danger-icon">
          <mat-icon svgIcon="close"></mat-icon>
          {{ "decline" | i18n }}
        </button>
        <button
          *ngIf="allowPartial"
          mat-menu-item
          type="button"
          data-cy="change-response-to-partial-button"
          (click)="onPartialAcceptClick()"
          class="success-icon">
          <mat-icon svgIcon="check-brackets-partial-accept"></mat-icon>
          {{
            (isAutoBookJob ? "partialAccept" : "partiallyIntrested") | titlecase
          }}
        </button>
        <button
          *ngIf="job?.yourself?.status !== InviteeStatusEnum.AVAILABLE"
          mat-menu-item
          type="button"
          data-cy="change-response-to-accept-button"
          (click)="onAcceptClick()"
          class="success-icon">
          <mat-icon svgIcon="check"></mat-icon>
          {{ (isAutoBookJob ? "accept" : "intrested") | i18n | titlecase }}
        </button>
      </ng-container>
      <button
        *ngIf="job?.yourself?.status === InviteeStatusEnum.BOOKED"
        class="outline-pill-button icon-left"
        type="button"
        (click)="downloadICS()">
        <mat-icon svgIcon="calendar-plus-save-download"></mat-icon>
        <span class="mat-fab__label">{{
          ("icsDownload" | i18n) || "Kalender" | titlecase
        }}</span>
      </button>
    </mat-menu>
  </ng-template>
</ng-container>
